// extracted by mini-css-extract-plugin
module.exports = {"userDropdownWrapper":"userDropdown_userDropdownWrapper__3e10a","userDropdownList":"userDropdown_userDropdownList__1jzIf"};